import React from 'react';

import FormCheckable from './checkable';

export default function FormCheckbox (props) {
  return <FormCheckable type='checkbox' {...props} />;
}
